export default {
  isContraste: false,
};
